<template>
  <span>

    <b-container fluid>
      <b-row class="table-header">
        <b-col cols="12" offset-lg="9" lg="3">
          <b-form-group>
            <b-form-input
              ref="search"
              v-model="meta.search"
              :disabled="fetching"
              placeholder="Search by question"
              @input="onSearchChanged"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <no-data v-if="!fetching && noData" message="No questions found..."/>

      <b-table
        v-if="questions.length"
        ref="table"
        :hover="!fetching"
        :responsive="true"
        :busy="fetching"
        :items="filtered"
        :fields="formFields"
        :no-local-sorting="false"
        :current-page="meta.currentPage"
        :per-page="meta.pageSize"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @row-clicked="rowClicked"
      >
        <template slot="actions" slot-scope="data">
          <div v-if="archived" class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="restore">
              <b-button
                :disabled="fetching"
                title="restore"
                variant="outline-secondary"
                @click.stop="onRestore(data.item)">
                <i class="fas fa-check"></i>
              </b-button>
            </span>
          </div>
          <div v-else class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="edit">
              <b-button
                :disabled="fetching"
                title="onEdit"
                variant="outline-secondary"
                @click.stop="onEdit(data.item)">
                <i class="fa fa-edit"></i>
              </b-button>
            </span>
            <span v-b-tooltip.hover style="display:inline-block" title="delete question">
              <b-button
                :disabled="fetching"
                title="delete question"
                variant="outline-secondary"
                @click.stop="onDelete(data.item)">
                <i class="fa fa-trash"></i>
              </b-button>
            </span>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col cols="12">
          <b-pagination
            v-if="filtered.length"
            v-model="meta.currentPage"
            :disabled="fetching"
            :total-rows="filtered.length"
            :per-page="meta.pageSize"
          />
        </b-col>
      </b-row>

    </b-container>
  </span>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import editQuestion from '../questions/edit'
import noData from '@/components/common/table/no-data'

export default {
  components:{
    editQuestion,
    noData
  },
  props:{
    view: {type: String, default: null},
    value: {type: Array, default:null}
  },
  data(){
    return {
      meta:{
        search:null,
        currentPage: 1,
        pageSize: 50
      },
      innerModel: {},
      filteredValues: null,
      formFields: [
        { key: 'text', label: 'Question', sortable:true },
        { key: 'actions', label: 'Actions', class: 'text-right align-top' }
      ],
      selectedQuestion: null,
      sortBy: 'text',
      sortDesc: false
    }
  },
  computed:{
    archived(){
      return this.view == 'archived'
    },
    noData(){
      return this.questions.length == 0
    },
    ...mapState('knowledgechecks', {
      fetching: state => state.views.component.fetching
    }),
    filtered(){
      return this.filteredValues || this.questions
    },
    questions(){
      return !this.value ? [] : this.value || []
    }
  },
  watch:{
    sortBy(val){
      this.meta.currentPage = 1
    },
    sortDesc(val){
      this.meta.currentPage = 1
    }
  },
  methods:{
    onEdit(question){
      this.$emit('edit-question', question)
    },
    onDelete(question){
      this.$emit('delete-question', question)
    },
    onRestore(question){
      this.$emit('restore-question', question)
    },
    rowClicked(question){
      this.onEdit(question)
    },
    onSearchChanged(){
      this.meta.currentPage = 1

      if(!this.meta.search){
        this.filteredValues = null
        return
      }

      const filterValue = this.meta.search.toLowerCase()

      this.filteredValues = _.filter(this.value, function(q){
        return q.text.toLowerCase().includes(filterValue)
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/components/table.vue